import { IonInput, IonItem, IonLabel, IonList } from '@ionic/react';
import StepLayout from './StepLayout';
import { modalToggleStore, userFormStore } from '../../../store/Store';

const Profile2 = () => {
    const detailUserForm = userFormStore.useState((s) => s.detailUserForm);
    const valid = Boolean((detailUserForm.last || '').trim());

    const setLast = (value) => {
        userFormStore.update((s) => {
            s.detailUserForm = { ...s.detailUserForm, last: value };
        });
    };

    const openThirdPage = () => {
        modalToggleStore.update((s) => {
            s.profilePage = 3;
        });
    };

    const continueOnEnter = (e) => {
        if (e.key === 'Enter' && valid) {
            openThirdPage();
        }
    };

    return (
        <StepLayout
            title={`Hi, ${detailUserForm.first}! What is your last name?`}
            primaryLabel='Continue'
            onPrimary={openThirdPage}
            primaryDisabled={!valid}
            hint={valid ? undefined : 'Enter your last name to continue.'}
        >
            <IonList lines='full'>
                <IonItem>
                    <IonLabel position='stacked'>Last name</IonLabel>
                    <IonInput
                        id='profile-last-name'
                        name='family-name'
                        autocomplete='family-name'
                        autocapitalize='words'
                        value={detailUserForm.last}
                        placeholder='Enter last name'
                        onIonChange={(e) => setLast(e.detail.value || '')}
                        onKeyDown={continueOnEnter}
                    />
                </IonItem>
            </IonList>
        </StepLayout>
    );
};

export default Profile2;
